import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Card, Col, Layout, Row, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import CustomHeader from "../Header";
import Footer from "../Footer";
import "./MaterialPlanning.css";
import {
  materialDashboardFeatures,
  materialFeatureText,
} from "./materialPlannigConstant";
import { scrollToElementById } from "../../../Utility/scrollUtils";
import { connect } from "react-redux";
import { Helmet } from "react-helmet-async";

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

export interface IMaterialPlanningProps {
  loginData: any;
}


const MaterialPlanning: React.FC<IMaterialPlanningProps> = ({ loginData }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToElementById("material");
  }, [pathname]);

  return (
    <div id="material">
      <Helmet>
        <title>Smarter Material Planning Software | Ease Margin</title>
        <meta
          name="description"
          content="Streamline production with EaseMargin’s material planning software. Align materials with demand, generate instant purchase requests, and ensure on-time delivery."
        />
        <link
          rel="canonical" href="https://easemargin.com/services/material-planning" />
      </Helmet>

      <CustomHeader />
      <Layout className="materialFeature-layout">
        <Header className="materialFeature-header">
          <div className="materialFeature-header-inner">
            <Title level={1} className="materialFeature-title-large">
              {materialFeatureText.HERO_TITLE}
            </Title>
            <Paragraph className="materialFeature-paragraph-header">
              {materialFeatureText.HERO_DESCRIPTION}
            </Paragraph>
            <Link to="/requestdemo">
              <Button type="primary" size="large" className="btn-orange">
                Request a Demo
              </Button>
            </Link>
          </div>
        </Header>
        <Content className="materialFeature-content">
          <Title level={2} className="materialFeature-title-2nd">
            {materialFeatureText.INTRO_TITLE}
          </Title>
          <Paragraph className="materialFeature-paragraph-main">
            {materialFeatureText.INTRO_DESCRIPTION}
          </Paragraph>

          <Title level={3} className="materialFeature-title-3rd-marginTop">
            {materialFeatureText.DASHBOARD_TITLE}
          </Title>
          <Row gutter={[24, 24]} style={{ marginBottom: 40 }}>
            {materialDashboardFeatures.map((feature, index) => (
              <Col xs={24} sm={12} key={index}>
                <Card
                  bordered={false}
                  className="card-default"
                  style={{ backgroundColor: "#F6FFED" }}
                >
                  <Paragraph className="materialFeature-paragraph-dashboard">
                    <CheckCircleOutlined
                      style={{ color: "#1890ff", marginRight: 8 }}
                    />
                    {feature}
                  </Paragraph>
                </Card>
              </Col>
            ))}
          </Row>

          <Title level={3} className="materialFeature-title-2nd">
            {materialFeatureText.FLEX_PLAN_TITLE}
          </Title>
          <Paragraph className="materialFeature-paragraph-main">
            {materialFeatureText.FLEX_PLAN_DESC}
          </Paragraph>
          <Card
            bordered={false}
            className="card-default materialFeature-card-footer"
          >
            <Title level={2} className="materialFeature-title-footer">
              {materialFeatureText.CTA_TITLE}
            </Title>
            <Link to="/requestdemo">
              <Button type="primary" size="large" className="btn-orange">
                {materialFeatureText.CTA_BUTTON}
              </Button>
            </Link>
          </Card>
        </Content>
      </Layout>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  loginData: state.api.login,
});

export default connect(mapStateToProps)(MaterialPlanning);
